/**
 * http client that support access and refresh token mechanism
 * this package needs to abstract away how refresh token is use
 * when an api's access token is expire and resume the api call
 * so the caller does not need to know anything about this mechanism
 * 
 */
import axios from "axios";
import Cookies from "js-cookie";
import Config from "./Config";


// TODO fix: race condition/multiple refresh token will be perform if api call called at the same time
const _apiCallRunner = async (apiCall) => {
    try {
        const resp = await apiCall(Cookies.get("access_token"));
        return resp;
    } catch (err) {
        // --- refresh token flow moved to interceptor.js ---
        throw err;
    }
}

const GET = async (url, params) => {
    const apiCall = async (accessToken) => {
        return axios.get(url, Config({
            Authorization: `Bearer ${accessToken}`
        }, params));
    };

    return await _apiCallRunner(apiCall);
}

const POST = async (url, data) => {
    const apiCall = async (accessToken) => {
        return axios.post(url, data, Config({
            Authorization: `Bearer ${accessToken}`
        }));
    }

    return await _apiCallRunner(apiCall);
}

const POSTFORM = async (url, data) => {
    const apiCall = async (accessToken) => {
        return axios.post(url, data, Config({
            Authorization: `Bearer ${accessToken}`,
            'content-type': 'multipart/form-data'
        }));
    }

    return await _apiCallRunner(apiCall);
}

const PUT = async (url, data) => {
    const apiCall = async (accessToken) => {
        return axios.put(url, data, Config({
            Authorization: `Bearer ${accessToken}`
        }));
    }

    return await _apiCallRunner(apiCall);
}

const DELETE = async (url, params) => {
    const apiCall = async (accessToken) => {
        return axios.delete(url, Config({
            Authorization: `Bearer ${accessToken}`
        }, params));
    }

    return await _apiCallRunner(apiCall);
}

const DOWNLOAD = async (url) => {
    const apiCall = async (accessToken) => {
        return axios.get(url, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            responseType: "blob",
        })
    };

    return await _apiCallRunner(apiCall);
}

export default {
    GET,
    POST,
    POSTFORM,
    PUT,
    DELETE,
    DOWNLOAD
}